import React, { useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { TtButton, TtIcon, TtTooltip } from '@23/ui-react'

import { useModal } from '../../../../Layout/Modal'
import { useConnectInfoQuery } from '../../../../global/blocs/useConnectInfo'
import { ConnectionDetailField } from '../../ConnectionDetailField/ConnectionDetailField'

import './StreamingDetails.scss'

export const StreamingDetails = () => {
  const { openModal } = useModal()
  const { data: connectInfo } = useConnectInfoQuery()
  const intl = useIntl()

  const handleClick = useCallback(() => {
    const connectionTypeLabel = connectInfo?.connection_type?.toUpperCase()

    openModal({
      className: 'streaming-details-modal',
      label: intl.formatMessage({
        defaultMessage: 'External streaming details',
      }),
      body: (
        <>
          <div className="streaming-details-intro">
            <FormattedMessage
              defaultMessage="Your {connectionTypeLabel} streaming credentials. Copy the server URL and stream key to configure your streaming software."
              values={{ connectionTypeLabel }}
            />
          </div>
          <ConnectionDetailField
            label={<FormattedMessage defaultMessage="Streaming Server" />}
            value={connectInfo?.connection_details_url}
            copyLabel={intl.formatMessage({
              defaultMessage: 'Copy streaming server URL',
            })}
          />
          <ConnectionDetailField
            label={<FormattedMessage defaultMessage="Stream Key" />}
            value={connectInfo?.connection_details_stream_key}
            copyLabel={intl.formatMessage({
              defaultMessage: 'Copy stream key',
            })}
          />
        </>
      ),
      closable: true,
    })
  }, [openModal, connectInfo, intl])

  return (
    <TtTooltip
      content={intl.formatMessage({ defaultMessage: 'View streaming details' })}
      placement="left"
      distance={16}
    >
      <TtButton
        circle
        color="secondary"
        label={intl.formatMessage({
          defaultMessage: 'View streaming details',
        })}
        onClick={handleClick}
      >
        <TtIcon name="info" library="one/global" />
      </TtButton>
    </TtTooltip>
  )
}
